import { useState, useEffect, useContext } from 'react'

import {
    Typography,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    List,
    ListItem,
    IconButton,
    ListItemText,
    CircularProgress,
    Button
} from '@mui/material'

import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DeleteIcon from '@mui/icons-material/Delete';

import { useTheme } from '@mui/material/styles';

import axios from 'axios'
import { api } from '../../../../utils/defaults'
import { UserContext } from '../../../../context/handleContext';
import hot from "react-hot-toast"
import { toast } from "react-toastify"

import {
    SelectedDayContext,
    SelectedCompanyContext,
    DespesaContext,
    AddDespesaContext,
    UpdateDayContext
} from '../../handleContext'

export default function Index (props) {
    const [selectedDay, setSelectedDay] = useContext(SelectedDayContext)
    const [selectedCompany, setSelectedCompany] = useContext(SelectedCompanyContext)
    const [addDespesa, setAddDespesa] = useContext(AddDespesaContext)
    const [updateDay, setUpdateDay] = useContext(UpdateDayContext)

    const [loading, setLoading] = useState(false)
    const [despesas, setDespesas] = useState([])
    const [despesa, setDespesa] = useContext(DespesaContext)
    const [user, setUser] = useContext(UserContext)

    const theme = useTheme()

    const update = () => {
        setLoading(true)
        axios
        .get(`${api}/api/manage/expense?datadespesa=${new Date(selectedDay.start).toISOString().split('T')[0]}&idloja=${selectedCompany?.idloja}`,{
            headers: {
                Authorization: user.token
            }
        })
        .then(response => {
            setDespesas(response.data)
            props.setDespesa(response.data.filter(({mesmoperiodo}) => mesmoperiodo).reduce((acumulator, next) => {
                return acumulator = acumulator + next.valor
            },0))
        })
        .catch(err => toast.error(err.response.data))
        .finally(() => setLoading(false))
    }

    useEffect(() => update(),[selectedDay, selectedCompany])
    useEffect(() => {
        if (updateDay.despesa) {
            update()
            setUpdateDay({ despesa: false })
        }
    },[updateDay])

    const deldespesa = (despesa) => {
        const del = () => {
            const t = hot.loading('Excluindo...')
            axios
            .delete(`${api}/api/manage/expense?iddespesa=${despesa.iddespesa}`,{
                headers: {
                    Authorization: user.token
                }
            })
            .then(response => {
                update({despesa:true})
                toast.success('Excluído')
                setDespesa({})
                setAddDespesa(false)
                props.updateDespesa()
            })
            .catch(err => toast.error(err.response.data))
            .finally(() => hot.dismiss(t))
        }
        const to = toast((t) => (
            <div>
                <Typography>Deseja realmente excluir ?</Typography>
                <div
                style={{
                    display:'flex',
                    justifyContent:"space-between",
                    width:'100%',
                    marginTop:'20px'
                }}>
                    <Button variant='contained' color='success' onClick={() => {
                        toast.dismiss(to)
                        del()
                    }}>sim</Button>
                    <Button variant='contained' color='error' onClick={() => toast.dismiss(to)}>não</Button>
                </div>
            </div>
        ),{
            duration: 10000
        })
    }

    return (
        <Accordion sx={{borderRadius:'5px'}}>
            <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
            >
                <div
                style={{
                    display:"flex",
                    alignItems:"center",
                    margin: '10px',
                    width:'100%'
                }}>
                    <div
                    style={{
                        width:'20px',
                        height:'20px',
                        borderRadius:'20px',
                        backgroundColor:'#f33e31',
                        display:"flex",
                        justifyContent:'center',
                        alignItems:"center",
                        padding:'10px'
                    }}>
                        <ArrowDownwardIcon sx={{color:theme.palette.mode==='dark'?'#fff':'#000', fontSize:'30px'}} />
                    </div>
                    <Typography sx={{ flexShrink: 0, marginLeft:'10px' }}>
                        Despesas
                    </Typography>
                    <Typography sx={{ color: 'text.secondary', marginLeft:'30px' }}>{despesas.reduce((acumulator, next) => {
                        return acumulator = acumulator + next.valor
                    },0)?.toLocaleString('pt-BR',{currency:'BRL',style:'currency'})}</Typography>
                </div>
            </AccordionSummary>
            <AccordionDetails>
                {loading ?
                <div style={{width:'100%',justifyContent:"center",display:"flex"}}><CircularProgress /></div>
                :
                <List 
                sx={{
                    //minWidth:'400px'
                }}
                dense={true}>
                    {despesas.map(e => (
                        <ListItem
                        secondaryAction={
                            <IconButton onClick={() => deldespesa(e)} edge="end" aria-label="delete">
                                <DeleteIcon />
                            </IconButton>
                        }
                        >
                            <ListItemText
                            primary={e.nome}
                            onClick={() => {
                                setDespesa({
                                    ...e, 
                                    // datadespesa: e.datadespesa ? new Date(new Date(e.datadespesa).setHours(new Date(e.datadespesa).getHours() - 3)).toISOString() : '',
                                    // dtpagamento: e.dtpagamento ? new Date(new Date(e.dtpagamento).setHours(new Date(e.dtpagamento).getHours() - 3)).toISOString() : ''
                                })
                                setAddDespesa(true)
                            }}
                            sx={{ cursor:'pointer' }}
                            secondary={
                                <div
                                style={{
                                    display:'flex',
                                    justifyContent:'space-between'
                                }}>
                                    <Typography>{e.valor?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</Typography>
                                    <div 
                                    style={{
                                        backgroundColor:e.cor,
                                        padding:'2px',
                                        borderRadius:'5px'
                                    }}>
                                        <Typography 
                                        sx={{
                                            fontSize:'12px',
                                            backgroundColor:theme.palette.mode==='dark'?'#1e1e1e':'#fff',
                                            padding:'2px',
                                            borderRadius:'5px'
                                        }}>
                                            {e.despesa}
                                        </Typography>
                                    </div>
                                </div>
                            }
                            />
                        </ListItem>
                    ))}
                </List>}
            </AccordionDetails>
        </Accordion>
    )
}